export const ImportStatusModelData = function () {
  return {
    importStatusList: [],
    queryParams: '',
    filename: ''
  }
}
